import Header from './Header';
import Footer from './Footer';
import AnnouncementBar from './AnnouncementBar';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <AnnouncementBar />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
